/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC45MyA3LjUwMDAxSDguNTAwMDFWMS4wNzAwMUg3LjUwMDAxVjcuNTAwMDFIMS4wNzAwMVY4LjUwMDAxSDcuNTAwMDFWMTQuOTNIOC41MDAwMVY4LjUwMDAxSDE0LjkzVjcuNTAwMDFaIiBmaWxsPSJpbmhlcml0Ii8+";